module.exports = __webpack_public_path__ + "static/img/mountain.4b7853d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mountain.jpg
// module id = YFym
// module chunks = 1